const PRODUCT_REVIEWS_HASH = '#product-reviews';

document.addEventListener('click', (event) => {
  const ratingLink = event.target.closest(`.product-shop-rating[href="${PRODUCT_REVIEWS_HASH}"]`);
  if (!ratingLink || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  const reviewHeading = document.querySelector('#bt-root .bt-title, .jdgm-rev-widg__title');
  const reviewsSection = document.querySelector(PRODUCT_REVIEWS_HASH) || reviewHeading?.closest('.apps-section');
  const target = reviewHeading || reviewsSection;

  if (!target) return;

  event.preventDefault();

  if (reviewHeading) {
    reviewsSection?.removeAttribute('id');
    reviewHeading.id = PRODUCT_REVIEWS_HASH.slice(1);
    reviewHeading.classList.add('product-reviews-anchor');
    reviewHeading.setAttribute('tabindex', '-1');
    reviewHeading.focus({ preventScroll: true });
  }

  history.pushState(null, '', PRODUCT_REVIEWS_HASH);
  target.scrollIntoView({
    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    block: 'start',
  });
});
